import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import TriangulationNavUI from './TriangulationNavUI.js'
import ChartsUI from '../../../components/superUser/clientTxn/ChartsUI.js'
// import './TriangulationChartPage.css'

const TriangulationChartPageUI = ({
  context, account, accountYearList, onRefreshClick,
  chartYearlyData, lastMonthsChartData, chartFromAprilData, quaterlyData,
  lastMonths, onLastMonthsChange, lastMonthsList,
  financialYear, onFinancialYearChange, financialYearList,
  showGpVNp, onShowGpVNp, showExpensesChart, onShowExpensesChart, selectLine, dataKeys
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_tri' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!accountYearList}
    account={account} page='triangulations'
  >
    {
      !accountYearList &&
      <SpinnerComponentUI />
    }
    {
      accountYearList &&
      <div className='body'>
        <div className='su_tri'>
          <LRTableActionsUI location='top'
            left={
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
                <span className='g_m_left_100 g_large'><b>Triangulation</b></span>
              </span>
            }
            right={<span />}
          />
          <TriangulationNavUI account={account} page='charts' />
        </div>

        {
          !accountYearList.length &&
          <div className='g_m_top_200 g_text_center'>No triangulations data</div>
        }
        {
          accountYearList.length !== 0 &&
          <ChartsUI
            context={context}
            account={account}
            accountYearList={accountYearList}
            chartYearlyData={chartYearlyData}
            lastMonthsChartData={lastMonthsChartData}
            chartFromAprilData={chartFromAprilData}
            quaterlyData={quaterlyData}
            //
            lastMonths={lastMonths}
            lastMonthsList={lastMonthsList}
            onLastMonthsChange={onLastMonthsChange}
            //
            financialYear={financialYear}
            financialYearList={financialYearList}
            onFinancialYearChange={onFinancialYearChange}
            //
            showGpVNp={showGpVNp}
            onShowGpVNp={onShowGpVNp}
            showExpensesChart={showExpensesChart}
            onShowExpensesChart={onShowExpensesChart}
            selectLine={selectLine}
            dataKeys={dataKeys}
          />
        }
      </div>
    }
  </SuperUserAccountPageUI>

export default TriangulationChartPageUI
